// Styles
import 'styles/app';

// Thirdparty
import 'what-input';
import 'owl.carousel';
import 'bootstrap';
import 'bootstrap-datepicker';
import 'bootstrap-select';
import 'jquery-validation';
require('magnific-popup');
require('malihu-custom-scrollbar-plugin');
var jQueryBridget = require('jquery-bridget');
var imagesLoaded = require('imagesloaded');

document.addEventListener('DOMContentLoaded', () => {
    if (window.jQuery) {
        var $ = window.jQuery;
        imagesLoaded.makeJQueryPlugin($);
    }
    if (window.Isotope) {
        var Isotope = window.Isotope;
        jQueryBridget('isotope', Isotope, $);
    }
    (r => {
        r
            .keys()
            .reduce((modules, script) => {
                const module = r(script).default;
                module && modules.push(module);
                return modules;
            }, [])
            .map(module => (module.can === true || module.can()) && module.run());
    })(require.context('scripts', true, /^(?!.*(common)).*\.js$/));
});

// document.body.classList.remove('preload');
